function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.4333 6.1333L11.2667 14.9333L7.23334 10.9",
  stroke: "#00BB77",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2416 12.9166C18.7833 16.4916 15.6666 19.3333 12 19.3333C7.96665 19.3333 4.66665 16.0333 4.66665 11.9999C4.66665 7.96659 7.96665 4.66659 12 4.66659C13.2833 4.66659 14.475 5.03325 15.575 5.58325L16.95 4.20825C15.4833 3.38325 13.8333 2.83325 12 2.83325C6.95831 2.83325 2.83331 6.95825 2.83331 11.9999C2.83331 17.0416 6.95831 21.1666 12 21.1666C16.7666 21.1666 20.6166 17.5916 21.075 12.9166H19.2416Z",
  fill: "#00BB77"
});
const SvgSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.4684bb6a.svg";
export { ForwardRef as ReactComponent };